'use client';

// import styled from 'styled-components';

import Footer from '@/ui/containers/layout/footer';
import Header from '@/ui/containers/layout/header';
// import { device } from '@/ui/styles/breakpoints';
// import { MAX_WIDTH } from '@/utils/breakpoints';
import LayoutContainer from '@/ui/containers/layout/LayoutContainer';

// const Wrap = styled.div`
//   display: flex;
//   flex-flow: column;
//   max-width: ${MAX_WIDTH.breakpointValue};
//   margin: 0 auto;
//   min-height: 100vh;
//   width: 100%;

//   @media ${device.min.md} {
//     padding-left: 1rem;
//     padding-right: 1rem;
//   }
// `;

export default function LayoutWithHeaderAndFooter({ children }) {
  return (
    <>
      <Header />
      <LayoutContainer>{children}</LayoutContainer>
      <Footer />
    </>
  );
}
